import { UnidadesFiltrosLimites } from './../models/UnidadesFiltroLimites';
import {Injectable, OnInit, OnChanges} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Solicitacao} from 'app/models/Solicitacao';
import {FormularioLateral} from 'app/models/FormularioLateral';
import {Unidades} from 'app/models/Unidades';
import { UnidadesFiltrosSolicitacao } from 'app/models/UnidadesFiltrosSolicitacao'
import { Subject } from 'rxjs';
import { Agente } from 'app/models/agente'
import { Usuario } from 'app/models/Usuario'

@Injectable()

export class DataService { //Service para troca de dados entre componentes

    public slt = new Solicitacao()

    public agente = new Agente()

    public formularioLtr  = new FormularioLateral()

    public unidades= new Unidades()
    public unidadesFiltrosSolicitacao = new UnidadesFiltrosSolicitacao()
    public unidadesFiltrosLimites = new UnidadesFiltrosLimites()

    public usuarios= new Usuario()

    public titleUsuarioForm = 'string';
    public sideBarIsOpen = true;


    public messageSource = new BehaviorSubject(this.slt) // OBSERVADOR DO OBJETO SOLICITAÇÃO
    currentMessage = this.messageSource.asObservable()

    public messageAgente = new BehaviorSubject(this.agente) // OBSERVADOR DO OBJETO AGENTE
    currentAgente = this.messageAgente.asObservable()

    public messageFormulario = new BehaviorSubject(this.formularioLtr) // OBSERVADOR DO OBJETO Formulario LATERAL
    currentFormulario = this.messageFormulario.asObservable()

    _observable = new Subject<string>(); // OBSERVADOR DOS ITENS DO Formulario DO SIDEBAR
    message$ = this._observable.asObservable();

    public messageUnidades = new BehaviorSubject(this.unidades) // OBSERVADOR DO OBJETO UNIDADES
    currentUnidades = this.messageUnidades.asObservable()

    public messageUsuarios = new BehaviorSubject(this.usuarios) // OBSERVADOR DO OBJETO USUARIOS
    currentUsuarios = this.messageUsuarios.asObservable()

    public messageAgentes = new BehaviorSubject(this.agente) // OBSERVADOR DO OBJETO AGENTES
    currentAgentes = this.messageAgentes.asObservable()

    public messageTitleUsuarioForm = new BehaviorSubject(this.titleUsuarioForm) // OBSERVADOR DO OBJETO USUARIOS
    currentTitleUsuarioForm = this.messageTitleUsuarioForm.asObservable()
    public messageunidadesFiltrosSolicitacao = new BehaviorSubject(this.unidadesFiltrosSolicitacao) // OBSERVADOR DO OBJETO UnidadesFiltrosSolicitacao
    currentunidadesFiltrosSolicitacao = this.messageunidadesFiltrosSolicitacao.asObservable()

    public messageunidadesFiltrosLimites = new BehaviorSubject(this.unidadesFiltrosLimites) // OBSERVADOR DO OBJETO UnidadesFiltrosLimites
    currentunidadesFiltrosLimites = this.messageunidadesFiltrosLimites.asObservable()


    public statusSideBarIsOpen = new BehaviorSubject<boolean>(this.sideBarIsOpen);




    constructor(){
        this.formularioLtr.status = false
    }


    receiveObj(slt: Solicitacao){
        this.messageSource.next(slt)
    }

    receiveUsuarios(usuarios: Usuario){
        this.messageUsuarios.next(usuarios)
    }

    receiveTitleUsuarioForm(title: string){
        this.messageTitleUsuarioForm.next(title)
    }

    changeFormulario(vl){
       this.messageFormulario.next(this.formularioLtr)
       this.formularioLtr.status = vl
    }

    sendMessage(message: string){
        this._observable.next(message);

      }

     changeUnidade(unidades: Unidades){
        this.messageUnidades.next(unidades)
     }

     receiveAgente(agente: Agente){
        this.messageAgente.next(agente)
    }

    alterarStatusSideBarIsOpen(valor: boolean) {
        this.statusSideBarIsOpen.next(valor);
      }
    obterStatusSideBarIsOpen() {
        return this.statusSideBarIsOpen;
      }

}



// WEBPACK FOOTER //
// ./src/app/services/data-service.ts